import { UnitOfMeasureModel } from "./unit-of-measure.model";
import { WineModel } from "./wine.model";

export class WineDefinitionModel {
    Id: number;
    WineId: number;
    UnitOfMeasureId: number;
    Vintage: number;
    CurrentValue: number;
    CurrentValueDate: Date;

    Wine: WineModel;
    UnitOfMeasure: UnitOfMeasureModel;

    constructor() {

    }
}